import { Component, Input, ViewEncapsulation, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { OrderCodeTextInputComponent } from '../../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { CheckboxLabelComponent } from '../../../../commons/kymw02/checkbox-label/checkbox-label.component';

/**
 * 画像情報詳細部品を管理するクラス
 *
 * @export ImageInfoListComponent
 * @class ImageInfoListComponent
 */
@Component({
  selector: 'app-image-info-list',
  templateUrl: 'image-info-list.component.html',
  styleUrls: ['image-info-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImageInfoListComponent implements OnInit {

  // 参照用
  @ViewChild('txi_OrderCode', { static: true }) public txi_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('btn_Search', { static: true }) public btn_Search: ElementRef;
  @ViewChild('btn_UseSearch', { static: true }) public btn_UseSearch: ElementRef;
  @ViewChild('hli_UseImageList', { static: true }) hli_UseImageList: ElementRef;
  @ViewChild('useImageGroups', { static: true }) useImageGroups: ElementRef;
  @ViewChild('chk_EPS', { static: true }) chk_EPS: CheckboxLabelComponent;
  @ViewChild('chk_PNG', { static: true }) chk_PNG: CheckboxLabelComponent;
  @ViewChild('chk_JPG', { static: true }) chk_JPG: CheckboxLabelComponent;

  // イベント
  @Output() eventUseImageList_ITEMCLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventOrderCode_CHANGE: EventEmitter<any> = new EventEmitter;
  @Output() eventBtnSearch_CLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventBtnUseSearch_CLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventAllSelect_CLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventAllUnSelect_CLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventImageOutput_CLICK: EventEmitter<any> = new EventEmitter;

  // レイアウト系の変数
  @Input() width: number = <number>100;
  @Input() height: number = <number>20;
  @Input() imageInfoList: Array<any> = new Array<any>();

  // 活性非活性フラグ
  public imageInfoListOrderCodeEnabled: boolean = <boolean>false;
  public btnUseSearchEnabled: boolean = <boolean>false;
  public btnAllSelectEnabled: boolean = <boolean>false;
  public btnAllUnSelectEnabled: boolean = <boolean>false;
  public btnImageOutputEnabled: boolean = <boolean>false;

  /** 受注コード  */
  public imageInfoListOrderCode: string = <string>'';
  /** データ件数  */
  public imageInfoListCnt: string = <string>'0';

  // 親画面からの連携値
  param: any;

  constructor(
    public dialogService: PlessDialogServiceSub,
  ) {
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
  }

  /**
   * ホイールで横スクロールする
   * @param $event 
   */
  scrollEvent($event: WheelEvent) {
    document.getElementById('hli_UseImageList').scrollBy({left: $event.deltaY, behavior: 'smooth'});
  }
}
